import React from 'react';
import { useTranslation } from 'react-i18next';
import PlaceholderImage from 'assets/img/notifications-placeholder.png';
import styles from './AbasPlaceholder.module.scss';
import clsx from 'clsx';

type OwnProps = {
  containerClassname?: string;
};

export const AbasPlaceholder = (props: OwnProps) => {
  const i18n = useTranslation();
  return (
    <div className={clsx(styles.columnContainer, props.containerClassname)}>
      <img src={PlaceholderImage} />
      <div className={clsx(styles.title, styles.marginTop4)}>
        {i18n.t('external_unavailable')}
      </div>
      <div className={styles.text}>{i18n.t('try_again_later')}</div>
    </div>
  );
};
